import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserLevel } from '../models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class UserLevelService {
  private http = inject(HttpClient);
  private baseUrl = environment.SWITCH_URL;

  getUserLevel() {
    const endPoint = '/user/api/v1/user/level';
    const apiUrl = this.baseUrl + endPoint;

    return this.http.get<UserLevel>(apiUrl, {});
  }
}
